/**
 * @generated SignedSource<<d71c28b9105d1837765b29d8202e66fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowHooksSendMessageViaConversationMutation$variables = {
  content: string;
  contentForDisplay?: string | null;
  conversationId: string;
  messageId?: string | null;
};
export type AskFellowHooksSendMessageViaConversationMutation$data = {
  readonly askCopilotSendMessage: {
    readonly conversation: {
      readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInnerFragment">;
    };
  } | null;
};
export type AskFellowHooksSendMessageViaConversationMutation = {
  response: AskFellowHooksSendMessageViaConversationMutation$data;
  variables: AskFellowHooksSendMessageViaConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentForDisplay"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "conversationId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "messageId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "content",
    "variableName": "content"
  },
  {
    "kind": "Variable",
    "name": "contentForDisplay",
    "variableName": "contentForDisplay"
  },
  {
    "kind": "Variable",
    "name": "conversationId",
    "variableName": "conversationId"
  },
  {
    "kind": "Variable",
    "name": "messageId",
    "variableName": "messageId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentForDisplay",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowHooksSendMessageViaConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AskCopilotSendMessage",
        "kind": "LinkedField",
        "name": "askCopilotSendMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AskFellowPanelInnerFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AskFellowHooksSendMessageViaConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AskCopilotSendMessage",
        "kind": "LinkedField",
        "name": "askCopilotSendMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotMessage",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentJson",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pending",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isResponse",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userRating",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedQuestion",
                "kind": "LinkedField",
                "name": "suggestedQuestions",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reachedMessageLimit",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d348c93a8b8c324995ea38671bae3b40",
    "id": null,
    "metadata": {},
    "name": "AskFellowHooksSendMessageViaConversationMutation",
    "operationKind": "mutation",
    "text": "mutation AskFellowHooksSendMessageViaConversationMutation(\n  $conversationId: ID!\n  $content: String!\n  $messageId: String\n  $contentForDisplay: String\n) {\n  askCopilotSendMessage(content: $content, conversationId: $conversationId, messageId: $messageId, contentForDisplay: $contentForDisplay) {\n    conversation {\n      ...AskFellowPanelInnerFragment\n      id\n    }\n  }\n}\n\nfragment AskFellowPanelInnerFragment on AskCopilotConversation {\n  id\n  title\n  messages {\n    id\n    role\n    content\n    contentJson\n    pending\n    createdAt\n    isResponse\n    contentForDisplay\n    ...AskFellowPanelInner_groupToolUsesWithResponse_message\n    ...AskFellowPanelInner_ToolUseAndResult_use\n    ...AskFellowPanelInner_ToolUseAndResult_result\n    ...AskFellowPanelInner_ChatMessage_message\n  }\n  suggestedQuestions {\n    id\n    ...AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion\n  }\n  reachedMessageLimit\n}\n\nfragment AskFellowPanelInner_ChatMessage_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentJson\n  contentForDisplay\n  pending\n  isResponse\n  ...AskFellowPanelInner_ToolUseAndResult_use\n  ...AskFellowPanelInner_RatingButtons_message\n}\n\nfragment AskFellowPanelInner_RatingButtons_message on AskCopilotMessage {\n  id\n  userRating\n}\n\nfragment AskFellowPanelInner_ToolUseAndResult_result on AskCopilotMessage {\n  contentJson\n}\n\nfragment AskFellowPanelInner_ToolUseAndResult_use on AskCopilotMessage {\n  contentJson\n}\n\nfragment AskFellowPanelInner_groupToolUsesWithResponse_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentForDisplay\n  contentJson\n}\n\nfragment AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion on SuggestedQuestion {\n  id\n  content\n  contentForDisplay\n}\n"
  }
};
})();

(node as any).hash = "c0d31b4693d1868ffd5ced85d6c2321c";

export default node;
